import { render, staticRenderFns } from "./Pathev.vue?vue&type=template&id=2406707d&scoped=true&lang=pug&"
import script from "./Pathev.vue?vue&type=script&lang=ts&"
export * from "./Pathev.vue?vue&type=script&lang=ts&"
import style0 from "./Pathev.vue?vue&type=style&index=0&id=2406707d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406707d",
  null
  
)

export default component.exports